import { createFeatureSelector } from "@ngrx/store";
import { AppSettings } from "../../components/shared-components/class/general-classes/app-settings";
import { Gateway } from "src/components/shared-components/class/general-classes/gateway";
import { GenericStoreApiData } from "src/components/shared-components/interfaces/generic-store-api-data";

/**
 * Selector for gateways
 */
export const listGateway = createFeatureSelector<GenericStoreApiData>(
  AppSettings.KEY_GATEWAYS
);

/**
 * Selector for gateways settings
 */
export const listGatewaySettings = createFeatureSelector<GenericStoreApiData>(
  AppSettings.KEY_GATEWAYS_SETTINGS
);
